import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { finalize, Subject, takeUntil } from 'rxjs'
import { MenuModel } from 'src/app/models/menu.model'
import { AyBService } from 'src/app/services/api/ayb.service'
import { ProductService } from 'src/app/services/api/product.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-dialog-asignar-menu',
  templateUrl: './dialog-asignar-menu.component.html',
  styleUrls: ['./dialog-asignar-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogAsignarMenuComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  isLoading = true
  kitchenMenus: MenuModel[] = []
  infoMenu: any = ''

  constructor (
    private readonly cdRef: ChangeDetectorRef,
    private readonly aybService: AyBService,
    private readonly productService: ProductService,
    public dialogAsignarMenuComponentRef: MatDialogRef<DialogAsignarMenuComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      nombreServicio: string
      serviceId: string
    }
  ) {}

  ngOnInit (): void {
    console.log({
      dialogData: this.data
    })
    this.aybService
      .queryGetAllKitchenMenus()
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        finalize(() => {
          this.isLoading = false
          console.log({
            menus: this.kitchenMenus
          })
          this.cdRef.markForCheck()
        })
      )
      .subscribe({
        next: ({ getAllKitchenMenus }) => {
          this.kitchenMenus = getAllKitchenMenus
        },
        error: error => {
          console.error('Error fetching menus:', error)
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron cargar los menús. Inténtalo de nuevo o contacta al soporte.'
          })
        }
      })
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  assignMenuToProductGroupedService () {
    console.log(this.infoMenu)
    delete this.infoMenu.descripcion
    delete this.infoMenu.costoMenu

    this.productService
      .mutationUpdateProductoAgrupado({
        id: this.data.serviceId,
        update: {
          menu: this.infoMenu
        }
      })
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(res => {
        console.log({
          res
        })
        Swal.fire({
          position: 'top-end',
          title: 'El menú se asignó satisfactoriamente',
          icon: 'success',
          showConfirmButton: false,
          timer: 5000
        })
        this.dialogAsignarMenuComponentRef.close(1)
      })
  }
}
